import DIApi from './_diApi';

class ToolTypeAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'ToolTypes';
}

export default new ToolTypeAPI();
